export default "__VITE_ASSET__CtEJaakZ__"